module.exports = __webpack_public_path__ + "img/shipo-icon-edit-primary.87ae1b01.svg";